import Logger, { DebugLevels, CompositeLogClient, ConsoleLogClient, setDebugLevel, getDebugLevel, setLogClient, getLogClient, addLevelsByMarker } from './Logger';
import JsonConsoleLogClient from './JsonConsoleLogClient';
export default Logger;
export { Logger, DebugLevels, CompositeLogClient, ConsoleLogClient, JsonConsoleLogClient, setDebugLevel, getDebugLevel, setLogClient, getLogClient, addLevelsByMarker };
